
import React, { useEffect, useState } from 'react'
import CustomTable from '../../Components/Table/CustomTable';

import { Grid } from '@mui/material';
import AllUserListCreateModal from './Modal/AllUserListCreateModal';
import AllUserTableViewModal from './Modal/AllUserTableViewModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../ReduxStore/actions';
import { setHeaderName, setSubHeaderName } from '../../ReduxStore/Slices/headerSlice';
import UserCreateByOperatorModal from '../Operator/Modal/UserCreateByOperatorModal';

const FinanicalConsultantList = () => {

  const dispatch = useDispatch();
  const { getAllFinanceConsultantListForAuthUser } = useSelector(
    (state) => state?.getAllFinanceConsultantListForAuthUser
  );

console.log(getAllFinanceConsultantListForAuthUser,"getAllFinanceConsultantListForAuthUser")



  const { managementRegisterForCustomer } = useSelector(
    (state) => state?.managementRegisterForCustomer
  );

  useEffect(() => {
    const data1 = {
      data: {
        // createdByUserId: sessionOperator_id,
        // createdByUserRole: UserRole,
      },
      method: "get",
      apiName: "getAllFinanceConsultantListForAuthUser",
    };

    dispatch(actions.GETALLFINANCECONSULTANTLISTFORAUTHUSER(data1));
  }, [dispatch,managementRegisterForCustomer]);

  const [rowTableData, setRowTableData] = useState([
    {
      Name: "--",
      CustomerId:"--",
      Email: "--",
      MobileNumber: "--",
      UserType: "--",
      Status: "--",
    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getAllFinanceConsultantListForAuthUser?.data?.map((data, index) => {
      return tempArr.push({
        Name: `${data?.first_name} ${data?.last_name}`,
        customer_id:data?.customer_id,
        Email: data?.email,
        MobileNumber: data?.phone,
        // UserType: data?.role,
        Status:
          data?.approval_status === "pending"
            ? "Pending"
            : data?.approval_status === "approved"
            ? "Approved"
            : "Unknown", // Add a default case if needed
      });   
    });
    setRowTableData(tempArr);
  }, [dispatch, getAllFinanceConsultantListForAuthUser,managementRegisterForCustomer]);

  const tableData = [
    { Name: 'Vallarasu', Email: "valla@gmail.com", MobileNumber: "1232343444", UserType: "Individual", Status: "Approved" },
    { Name: 'Pravin', Email: "pravin@gmail.com", MobileNumber: "98787687687", UserType: "Individual", Status: "Approved" },
    { Name: 'Shahul', Email: "shahul@gmail.com", MobileNumber: "123322443543", UserType: "Individual", Status: "Approved" },
    { Name: 'Ramesh', Email: "Ramesh@gmail.com", MobileNumber: "76575675664", UserType: "Individual", Status: "Approved" },
    { Name: 'Sanjeev', Email: "Sanjeev@gmail.com", MobileNumber: "909878789709", UserType: "Financial Consultant", Status: "Pending" },



  ];

  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  


   React.useEffect(() => {
        dispatch(setHeaderName("Operator Registration"));
        dispatch(setSubHeaderName("Financial Consultant List"));
      }, [dispatch]);
    
  const tableHeadData = ['S.No', 'Consultant Name', "Email Id", "Mobile Number",'Status'];
  return (
    <Grid container spacing={2}>

      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable tableData={rowTableData} title="Financial Consultant List" tableHeadData={tableHeadData}
          modalName={UserCreateByOperatorModal}
          // tableEdit="tableEdit"
          tableView="tableView"
          userApprovalModel="userApprovalModel"
          modalVeiwName={AllUserTableViewModal}
          modalViewHeadingName="User Detail"
          dataCreate={permissions?.OperatorRegistration?.["Financial Consultant List"]?.add}

          options={[
          
            { label: "Financial Consultant", value: "finance_consultant" },
          ]}
          modalHeadingName="Create User"
        />

      </Grid>
    </Grid>
  )
}

export default FinanicalConsultantList